import { render, staticRenderFns } from "./typeIntroduce.vue?vue&type=template&id=64db4486&scoped=true&"
import script from "./typeIntroduce.vue?vue&type=script&lang=js&"
export * from "./typeIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./typeIntroduce.vue?vue&type=style&index=0&id=64db4486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db4486",
  null
  
)

export default component.exports